import { motion } from "framer-motion";

export function Hero() {
  return (
    <section className="bg-background border-b-4 border-primary">
      {/* Breaking banner */}
      <div className="bg-primary/10 border-b border-primary/20 px-4 py-2">
        <div className="max-w-6xl mx-auto">
          <div className="flex items-center gap-3 overflow-hidden">
            <span className="bg-primary text-primary-foreground text-xs font-black px-3 py-1 rounded-sm uppercase tracking-wide flex-shrink-0">
              Son Dakika
            </span>
            <p className="text-sm text-foreground font-medium whitespace-nowrap animate-pulse">
              🎊 23 Nisan Ulusal Egemenlik ve Çocuk Bayramı'mız Kutlu Olsun! Türkiye Büyük Millet Meclisi 106 yaşında! 🇹🇷
            </p>
          </div>
        </div>
      </div>

      {/* Main headline area */}
      <div className="max-w-6xl mx-auto px-4 py-8">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          {/* Main story */}
          <div className="lg:col-span-2">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
            >
              <div className="flex items-center gap-2 mb-3">
                <span className="bg-primary text-primary-foreground text-xs font-bold px-2 py-0.5 rounded uppercase tracking-wider">
                  Manşet
                </span>
                <span className="text-muted-foreground text-xs">23 Nisan 2026</span>
              </div>
              <h1 className="text-4xl sm:text-5xl font-black text-foreground leading-none mb-4"
                style={{ fontFamily: "'Merriweather', serif" }}>
                Milli İrade 106 Yıldır{" "}
                <span className="text-primary">Yaşıyor!</span>
              </h1>
              <div className="w-full h-1 bg-gradient-to-r from-primary via-primary/50 to-transparent mb-4" />
              <p className="text-lg text-muted-foreground leading-relaxed mb-4">
                <strong className="text-foreground">23 Nisan 1920'de</strong> Ankara'da açılan Türkiye Büyük Millet Meclisi,
                Türk milletinin kendi kaderini kendi ellerine almasının simgesi oldu. O günden bu yana 106 yıl geçti
                ve bu tarih her yıl milyonlarca çocuğun bayramı olarak kutlanıyor.
              </p>
              <p className="text-sm text-muted-foreground leading-relaxed">
                Mustafa Kemal Atatürk, 1927 yılında bu tarihi günü Türkiye'nin çocuklarına armağan etti. Bugün
                110'dan fazla ülkeden çocuklar bu büyük bayramı birlikte kutluyor.
                Dünyada çocuklara resmi bayram armağan eden <strong>tek ülke Türkiye</strong>'dir.
              </p>

              {/* Key stats */}
              <div className="grid grid-cols-3 gap-3 mt-6">
                {[
                  { num: "106", label: "Yıllık Bayram", icon: "🎂" },
                  { num: "110+", label: "Ülke Katılıyor", icon: "🌍" },
                  { num: "1920", label: "Kuruluş Yılı", icon: "🏛️" },
                ].map((stat) => (
                  <div key={stat.num} className="bg-card border border-border rounded-xl p-4 text-center">
                    <div className="text-2xl mb-1">{stat.icon}</div>
                    <div className="text-2xl font-black text-primary" style={{ fontFamily: "'Merriweather', serif" }}>
                      {stat.num}
                    </div>
                    <div className="text-xs text-muted-foreground mt-0.5">{stat.label}</div>
                  </div>
                ))}
              </div>
            </motion.div>
          </div>

          {/* Side column */}
          <div className="space-y-5">
            {/* Flag visual */}
            <motion.div
              initial={{ opacity: 0, scale: 0.95 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.6, delay: 0.2 }}
              className="relative rounded-2xl overflow-hidden border-2 border-primary/20 flex items-center justify-center"
              style={{
                background: "linear-gradient(135deg, #E30A17 0%, #c00812 100%)",
                height: "220px",
              }}
            >
              <div className="absolute inset-0 flex items-center justify-center">
                {/* Turkish flag star and crescent */}
                <div className="text-9xl select-none opacity-30">🇹🇷</div>
              </div>
              <div className="relative z-10 text-center px-6">
                <p className="text-white text-3xl font-black" style={{ fontFamily: "'Merriweather', serif" }}>
                  23 NİSAN
                </p>
                <p className="text-yellow-200 text-sm font-semibold mt-1">Ulusal Egemenlik</p>
                <p className="text-yellow-200 text-sm font-semibold">ve Çocuk Bayramı</p>
              </div>
            </motion.div>

            {/* Quick info card */}
            <motion.div
              initial={{ opacity: 0, x: 20 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.5, delay: 0.3 }}
              className="bg-card border-2 border-border rounded-xl p-4"
            >
              <h3 className="font-black text-sm text-foreground mb-3 uppercase tracking-wide border-b border-border pb-2">
                📌 Hızlı Bilgi
              </h3>
              <ul className="space-y-2.5 text-sm">
                {[
                  ["📅", "İlan Yılı", "1921"],
                  ["👶", "Çocuk Bayramı", "1927"],
                  ["🌐", "Uluslararası", "1979"],
                  ["🏛️", "Özel Meclis Oturumu", "Her yıl"],
                  ["🎯", "Hedef Yaş", "Tüm çocuklar"],
                ].map(([icon, label, val]) => (
                  <li key={label} className="flex items-center justify-between gap-2">
                    <span className="text-muted-foreground flex items-center gap-1.5">
                      <span>{icon}</span>
                      <span>{label}</span>
                    </span>
                    <span className="font-semibold text-foreground">{val}</span>
                  </li>
                ))}
              </ul>
            </motion.div>
          </div>
        </div>
      </div>
    </section>
  );
}
